import axios from './axios';
import { getAccessToken } from '../common';

export const fetch_application = async (applicationId) => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/applications/${applicationId}`
    
  var config = {
    method: 'get',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const upload_file = async (applicationId, file) => {
  try{
    let formData = new FormData();
    formData.append("file", file);

    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/applications/${applicationId}/upload`,
      headers: { 
        "Content-Type": "multipart/form-data"
      },
      data : formData
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const download_file = async (applicationId, filename) => {
  try{
    var token = getAccessToken()
    if(token) {
      var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/applications/${applicationId}/files/${filename}`
      var headers = new Headers()
      headers.append("x-auth-token", `Bearer ${token}`)

      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      };

      fetch(url, requestOptions)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `sample.${filename}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch(error => console.log('error', error));
    }
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const fetch_appointments = async (applicationId, limit, skip) => {
  var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/applications/${applicationId}/appointments?`

  if(skip)
    url += `&skip=${skip}`
  if(limit)
    url += `&limit=${limit}`
    
  var config = {
    method: 'get',
    url: url,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  try {
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const insert_appointments = async (applicationId, object) => {
  try{
    var data = JSON.stringify(object);

    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/applications/${applicationId}/appointments`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const delete_appointments = async (applicationId, appointmentId) => {
  try{
    var config = {
      method: 'delete',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/applications/${applicationId}/appointments/${appointmentId}`,
      headers: { 
        'Content-Type': 'application/json'
      }
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}

export const update_application = async (applicationId, data) => {
  try{
    var data = JSON.stringify(data);

    var config = {
      method: 'patch',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/applications/${applicationId}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}